"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _user = require("_a/admin/user/user");
var _message = require("_l/message");
var _role = require("_a/admin/role/role");
var _vuex = require("vuex");
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _dept = require("_a/admin/dept/dept");
var _post = require("_a/admin/post/post");
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'user-manage',
  components: {
    TablePage: _tablePage.default,
    VueTreeselect: _vueTreeselect.default
  },
  data: function data() {
    var _this = this;
    var validateUsernameCount = function validateUsernameCount(rule, value, callback) {
      if (value !== '') {
        (0, _user.getUserInfoByUsername)(_this.form.username).then(function (res) {
          if (res.data !== null) {
            if (_this.form.userId === res.data.userId) {
              callback();
            } else {
              callback(new Error('用户名重复，请重新输入'));
            }
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    };
    var validatePassCheck = function validatePassCheck(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入确认密码'));
      } else if (value !== _this.form.password) {
        callback(new Error('两次密码不一致，请重新输入'));
      } else {
        callback();
      }
    };
    return {
      tableUrl: '/system/user/pageList',
      columns: [{
        label: '部门',
        prop: 'deptName'
      }, {
        label: '用户名',
        prop: 'username',
        sortable: 'custom'
      }, {
        label: '昵称',
        prop: 'nickName'
      }, {
        label: '手机号码',
        prop: 'phoneNumber'
      }, {
        label: '性别',
        slot: 'sex'
      }, {
        label: '状态',
        slot: 'userStatus'
      }, {
        label: '操作',
        slot: 'action',
        width: 400
      }],
      queryParams: {},
      dialogShow: false,
      dialogAuthRoleShow: false,
      delBtnDisabled: true,
      dialogTitle: '添加用户',
      form: {},
      ids: [],
      rules: {
        deptId: [this.$ruler('部门')],
        username: [this.$ruler('用户名'), {
          type: 'string',
          max: 16,
          min: 6,
          message: '请输入6-16个字符',
          trigger: 'blur'
        }, {
          validator: validateUsernameCount,
          trigger: 'blur'
        }],
        password: [this.$ruler('密码'), {
          type: 'string',
          max: 16,
          min: 6,
          message: '请输入6-16个字符',
          trigger: 'blur'
        }],
        passwordCheck: [this.$ruler('确认密码'), {
          validator: validatePassCheck,
          trigger: 'blur'
        }],
        nickName: [this.$ruler('昵称')],
        phoneNumber: [this.$ruler('手机号')]
      },
      sexOptionList: [],
      statusOptionList: [],
      // 授权角色使用
      userId: null,
      roleList: [],
      targetKeys: [],
      // 组织机构数据
      deptTree: [],
      // 岗位数据
      postList: [],
      normalizer: function normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        };
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    change: function change(e) {
      this.$forceUpdate();
    },
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    /**
     * 添加弹出框
     */
    addUser: function addUser() {
      this.form = {
        password: null,
        userType: 1,
        userStatus: '0'
      };
      this.dialogTitle = '添加用户';
      this.dialogShow = true;
    },
    /**
     * 修改弹出框
     * @param row
     */
    update: function update(row) {
      var _this2 = this;
      this.form = _objectSpread({}, row);
      this.dialogTitle = '修改用户';
      (0, _user.getPostListByUserId)(row.id).then(function (res) {
        if (res.data) {
          _this2.form.postIds = res.data;
        }
        _this2.$nextTick(function () {
          this.dialogShow = true;
        });
      });
    },
    /**
     * 点击每一行的checkbox
     */
    selectVal: function selectVal(ids) {
      this.ids = ids.map(function (val) {
        return val['id'];
      });
      this.delBtnDisabled = !this.ids.length;
    },
    /**
     * 批量删除
     */
    removeBatch: function removeBatch() {
      var _this3 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _user.deleteBatchUserInfoById)(_this3.ids).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          _this3.refresh();
        });
      });
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this4 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _user.deleteUserInfoById)(row.id).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          // 刷新表格
          _this4.refresh();
        });
      });
    },
    /**
     * 重置密码
     * @param row
     */
    resetPassword: function resetPassword(row) {
      var _this5 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }, '确定重置密码123456吗?').then(function () {
        row.password = '123456';
        (0, _user.resetPassword)(row).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('upd');
          } else {
            (0, _message.MessageError)('upd');
          }
          // 刷新表格
          _this5.refresh();
        });
      });
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.dialogShow = false;
      this.$refs[name].resetFields();
    },
    /**
     * 提交表单
     * @param name
     */
    handleSubmit: function handleSubmit(name) {
      var _this6 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this6.dialogTitle === '添加用户') {
            (0, _user.addUserInfo)(_this6.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('add');
              } else {
                (0, _message.MessageError)('add');
              }
              _this6.cancelDialogAndRefresh();
            });
          } else {
            (0, _user.updateUserInfo)(_this6.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('upd');
              } else {
                (0, _message.MessageError)('upd');
              }
              _this6.cancelDialogAndRefresh();
            });
          }
        }
      });
    },
    /**
     * 关闭弹出框 和 刷新表格
     */
    cancelDialogAndRefresh: function cancelDialogAndRefresh() {
      // 清空表单
      this.handleReset('form');
      // 刷新表格
      this.refresh();
    },
    /**
     * 关闭授权角色弹出框
     */
    cancelAuthRoleDialog: function cancelAuthRoleDialog() {
      this.dialogAuthRoleShow = false;
    },
    filterMethod: function filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    /**
     * 授权角色
     * @param row
     */
    authRole: function authRole(row) {
      var _this7 = this;
      this.userId = row.id;
      (0, _user.getAuthRoleListByUserId)(this.userId).then(function (res) {
        _this7.targetKeys = res.data.map(function (e) {
          return e.id;
        });
      }).then(function () {
        (0, _role.getRoleAllList)().then(function (res) {
          if (res.data) {
            var roleList = [];
            res.data.forEach(function (e) {
              var role = {
                key: e.id,
                label: e.roleName,
                disabled: e.roleStatus === '1'
              };
              roleList.push(role);
            });
            _this7.roleList = roleList;
          }
        });
      }).then(function () {
        _this7.$nextTick(function () {
          this.dialogAuthRoleShow = true;
        });
      });
    },
    /**
     * 保存授权角色
     */
    saveAuthRole: function saveAuthRole() {
      var _this8 = this;
      var userInfoRoleDTO = {
        userId: this.userId,
        roleIds: this.targetKeys
      };
      (0, _user.saveAuthRole)(userInfoRoleDTO).then(function (res) {
        if (res.data) {
          (0, _message.MessageSuccess)('save');
        } else {
          (0, _message.MessageError)('save');
        }
        _this8.cancelAuthRoleDialog();
        // 刷新表格
        _this8.refresh();
      });
    },
    getDeptTreeList: function getDeptTreeList() {
      var _this9 = this;
      (0, _dept.getDeptTreeList)().then(function (res) {
        if (res.data) {
          _this9.deptTree = res.data;
        }
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      this.queryParams.deptId = data.id;
      this.$nextTick(function () {
        this.refresh();
      });
    },
    toDeptView: function toDeptView() {
      this.$router.push('/admin/dept-manage');
    },
    getPostList: function getPostList() {
      var _this0 = this;
      (0, _post.getPostListAll)().then(function (res) {
        if (res.data) {
          _this0.postList = res.data;
        }
      });
    }
  }),
  mounted: function mounted() {
    var _this1 = this;
    this.getDeptTreeList();
    this.getPostList();
    this.getDictListByType('sex').then(function (res) {
      _this1.sexOptionList = res;
    });
    this.getDictListByType('user_status').then(function (res) {
      _this1.statusOptionList = res;
    });
  }
};